<template>
  <div id="check-in-page-history">
    <p class="subheader-style">
      <v-icon
        large
        left
        color="#37474F"
      >
        mdi-history
      </v-icon>
      Your Previous Check-In
    </p>
    <v-card
      elevation="0"
      color="#FFF"
      class="check-in-history"
    >
      <div
        v-if="
          !isPreviousRecordAvailable || isCheckedInFromKiosk || !isNotCostShift
        "
        class="empty-alert-div"
      >
        <br>
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No records found
        </p>
        <br>
        <br>
      </div>
      <div
        v-if="
          isPreviousRecordAvailable && !isCheckedInFromKiosk && isNotCostShift
        "
      >
        <v-card-text>
          <p class="title-text-style">
            Project:
            <span class="value-text-style">
              {{ previousCheckInDetails.project.name }}
            </span>
          </p>
          <p class="title-text-style">
            Check-in Gate :
            <span class="value-text-style">
              {{ previousCheckInDetails.checkin_gate.name }}
            </span>
          </p>
          <p class="title-text-style">
            Check-in Type :
            <span class="value-text-style">
              {{ previousCheckInDetails.type | arrangePretty }}
            </span>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <div class="action-btn-icon">
            <p class="title-text-style">
              Continue Same Check-in?
              <v-btn
                color="#37474F"
                elevation="0"
                fab
                x-small
                @click="repeatPreviousCheckIn()"
              >
                <v-icon> mdi-chevron-right </v-icon>
              </v-btn>
            </p>
          </div>
        </v-card-actions>
      </div>
    </v-card>
    <center-spinner :loading="loading" />
    <check-in-sheet
      v-if="openCheckinSheet"
      :previous-checkin="previousCheckInDetails"
      :location-enable-check="locationEnableCheck"
      :check-in-type="'previous'"
      @closed="openCheckinSheet = false"
    />
  </div>
</template>

<script>
import spinner from '../../components/SpinnerCentre.vue';
import CheckInSheet from './CheckInSheet.vue';
export default {
  name: 'CheckInPageHistory',
  components: {
    'center-spinner': spinner,
    'check-in-sheet': CheckInSheet,
  },
  filters: {
    arrangePretty (val) {
      if (val === 'staff') {
        return 'Site Manager';
      } else {
        return val;
      }
    },
  },
  data: () => ({
    loading: false,
    openCheckinSheet: false,
  }),
  computed: {
    previousCheckInDetails () {
      return this.$store.getters['swiftuser/getPreviousCheckInDetails'];
    },
    isPreviousRecordAvailable () {
      if (Object.keys(this.previousCheckInDetails).length > 0) {
        return true;
      }
      return false;
    },
    isCheckedInFromKiosk () {
      if (
        this.previousCheckInDetails.checkout_kiosk !== null ||
        this.previousCheckInDetails.checkin_kiosk !== null
      ) {
        return true;
      }
      return false;
    },
    isNotCostShift () {
      if (
        this.previousCheckInDetails.checkin_method_type !== 'cost-shift' &&
        this.previousCheckInDetails.checkout_method_type !== 'cost-shift'
      ) {
        return true;
      }
      return false;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    orgSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    locationEnableCheck () {
      return this.orgSettings.location_verification;
    },
    isOrgAvailable () {
      if (
        this.selectedOrganization !== null &&
        this.selectedOrganization !== undefined
      ) {
        return true;
      }
      return false;
    },
  },
  async mounted () {
    (await this.isOrgAvailable) && (await this.getPreviousCheckInDetails());
  },
  methods: {
    async getPreviousCheckInDetails () {
      this.loading = true;
      await this.$store
        .dispatch('swiftuser/fetchPreviousCheckInDetails', {
          orgExtId: this.selectedOrganization.organization.external_id,
        })
        .catch(() => {
          this.loading = false;
        });
      this.loading = false;
    },
    repeatPreviousCheckIn () {
      this.loading = true;
      this.$store.dispatch(
        'organization/selectedOrganization',
        this.previousCheckInDetails.app_user,
      );
      this.$store.dispatch('swiftuser/storeCheckInMethodType', {
        type: 'manual-checkin',
      });
      setTimeout(() => {
        this.openCheckinSheet = true;
        // this.$router.push(`/check-in/${this.previousCheckInDetails.checkin_gate.id}/${this.previousCheckInDetails.type}`);
        this.loading = false;
      }, 1000);
    },
  },
};
</script>
<style scoped>
#check-in-page-history {
  margin-top: 20px;
  padding-bottom: 60px;
}
</style>
